import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Legal consent checkbox shown on both Sign In and Sign Up.
 * Required for NDPA / GDPR compliance — gates submit + Google buttons in parent.
 */
const ConsentRow = ({ checked, onChange, isLogin }) => {
  return (
    <label className="flex items-start gap-2 cursor-pointer select-none" data-testid="legal-consent-row">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 h-4 w-4 rounded border-gray-300 text-green-600 focus:ring-green-500"
        data-testid="legal-consent-checkbox"
      />
      <span className="text-xs text-gray-600 leading-relaxed">
        {isLogin ? 'By signing in,' : 'By creating an account,'} I acknowledge that I have read and agree to the{' '}
        <Link to="/legal/terms" target="_blank" className="text-green-700 hover:underline font-medium" data-testid="legal-consent-terms-link">Terms &amp; Conditions</Link>,{' '}
        <Link to="/legal/privacy" target="_blank" className="text-green-700 hover:underline font-medium" data-testid="legal-consent-privacy-link">Privacy Policy</Link> and{' '}
        <Link to="/legal/cookies" target="_blank" className="text-green-700 hover:underline font-medium" data-testid="legal-consent-cookies-link">Cookie Notice</Link> of Daye Farm Ltd.
      </span>
    </label>
  );
};

export default ConsentRow;
